import angular from 'angular';
import './resource';
import '../app.constants';
import { isEmpty, get, values, map, some, forEach, find, filter, merge } from 'lodash';
import '../resources/subscription';

const module = angular.module('whyline.resources.group', [
  'whyline.constants',
  'whyline.resources.resource',
  'whyline.resources.subscription',
]);

const GroupFactory = (API_URL, $http, Resource, Subscription, Socket) => {
  /*@ngInject*/
  //API REST Resource Name
  const _type = 'group?placeId';

  const _schema = {
    label: {
      type: String,
      required: true,
    },
    lines: {
      type: [],
      required: true,
    },
    enabled: {
      type: Boolean,
      required: true,
    },
    configuration: {
      automaticCall: {
        enabled: Boolean,
      },
    },
  };

  const Group = function (data) {
    angular.forEach(_schema, (prop, key) => {

      this[key] = prop.default;
    });

    angular.forEach(data, (prop, key) => {
      this[key] = prop;
    });

    this.cachedLineWaitingPeople = {};

    forEach(this.lines, ({ _id, waitingPeople }) => {
      this.cachedLineWaitingPeople[_id] = waitingPeople;
    });
  };

  Group.GetAllGroups = () => {
    const url = `${API_URL}${_type}`;
    return $http.get(url).then((response) => response.data);
  };

  Group.GetMyGroups = (options) => {
    const cacheUrl = `${API_URL}group/allowed`;
    const force = options && options.force;
    const promise = options && options.promise;
    const cacheExists = Group.SearchCacheExists(cacheUrl);
    const list = Group.GetCacheSearch(cacheUrl);
    if (isEmpty(list) && !cacheExists) {
      return Group.FetchAll({ promise, force }).then((groups) => {
        if (groups) {
          Group.UpdateCacheSearch(cacheUrl, values(groups), {});
        }
        return Group.GetCacheSearch(cacheUrl);
      });
    }
    return list;
  };

  Group.GetAllForNowServing = (options) => {
    const cacheUrl = `${API_URL}${_type}/now-serving`;
    const force = options && options.force;
    const promise = options && options.promise;
    const cacheExists = Group.SearchCacheExists(cacheUrl);
    const list = Group.GetCacheSearch(cacheUrl);
    if (isEmpty(list) && !cacheExists) {
      return $http.get(cacheUrl).then((response) => {
        if (response.data) {
          Group.UpdateCacheSearch(cacheUrl, values(response.data), {});
        }
        return Group.GetCacheSearch(cacheUrl);
      });
    }
    return list;
  };

  Group.CallNext = async (groupId) => {
    try {
      const url = `${API_URL}group/${groupId}/call-next?placeId`;
      const response = await $http.post(url);
      const subscription = response.data;

      Subscription.UpdateCache(subscription._id, subscription);

      return subscription;
    } catch (error) {
      if(error.status === 406 || error.status === 409) {
        console.warn(`[Group] CallNext - calling error, with status: ${error.status}, with reason: ${error.reason}, with message: ${error.data.message}, with details: ${error.data}`);
        return;
      }

      throw error;
    }
  };

  Group.CallTo = (subscriptionId, groupId) => {
    try {
      const url = `${API_URL}subscription/${subscriptionId}/call-to?queueId=${groupId}&queueType=group?placeId`;
      return $http.post(url).then((response) => {
        const subscription = response.data;
        Subscription.UpdateCache(subscription._id, subscription);
        return Promise.resolve(subscription);
      });
    } catch (error) {
      if(error.status === 406 || error.status === 409) {
        console.warn(`[Group] CallTo - calling error, with status: ${error.status}, with reason: ${error.reason}, with message: ${error.data.message}, with details: ${error.data}`);
        return;
      }

      throw error;
    }
  };

  Group.Update = async (groupUpdate) => {
    const url = `${API_URL}group/${groupUpdate._id}`;
    return $http({
      method: 'PUT',
      url: url,
      data: groupUpdate.data,
    }).then(response => {
      return Promise.resolve(response);
    });
  };
  
  Group.getFromCacheByLine = (lineId) => {
    const cachedGroups = Group.GetAllFromCache();

    return filter(cachedGroups, (g) => {
      const lines = get(g, 'lines');
      const ids = map(lines, '_id');
      const any = ids.includes(lineId);

      return any;
    });
  };

  Group.UpdateWaitingPeople = (line) => {
    const cachedGroups = Group.GetCacheSearch(`${API_URL}${_type}/now-serving`);

    forEach(cachedGroups, (group) => {
      if (some(group.lines, ['_id', line._id])) {
        merge(
          find(group.lines, ['_id', line._id]),
          {
            waitingPeople: line.waitingPeople,
            inPlace: line.inPlace
          }
        );
      }
    });
  };

  Group.GetOneById = groupId => {
    const url = `${API_URL}group/searchById?id=${groupId}`;
    return $http.get(url).then(response => response.data);
  };

  Group.prototype = new Resource(_type, _schema, Group);

  Resource.Extend(_type, Group);

  //five minutes
  const validityTime = 5 * 60 * 1000;
  Group.InitCache(validityTime);

  return Group;
};

module.exports = module.factory('Group', GroupFactory);
